import immediateApi from "../../api/immediateApi";
let hasConnection = true;

export function updateEndStopPorts(actuator, pEndStopConfig = undefined, pCallback = undefined) {
  // Sync or Async function, depending on pEndStopConfig
  // Note : Always call updateEndStopPorts after immediateApi.getEndStopConfig or immediateApi.setEndStopConfig on the global actuator.

  if (pEndStopConfig !== undefined) {
    actuator.homeport = pEndStopConfig.home;
    actuator.endport = pEndStopConfig.end;
    if (pCallback) { pCallback(); }
  }
  else {
    immediateApi.getEndstopConfig(actuator.parameters.controllerId, actuator.driveNumber)
      .then((pData) => {
        actuator.homeport = pData.home;
        actuator.endport = pData.end;
        if (pCallback) { pCallback(); }
      }).catch(configCheckerOnErrorCallback);
  }

}

export function listAllValidatables() {
  return [ 'driveNumberValidatable', 'directionValidatable', 'homeSensorValidatable', 'endSensorValidatable'];
}


export function configCheckerOnErrorCallback() {
  if (hasConnection) {
    hasConnection = false;
    if(window._style){
      window._style.messageBox('Lost connection to immediate engine, reloading.', 'error');
    }
    console.log('refreshing');
    setTimeout(()=>{ leaveConfigChecker(); }, 2000);
  }
}


let leaveConfigCheckerCB = undefined;
export function leaveConfigChecker() {
  if (!leaveConfigCheckerCB) {
    throw new Error("There is no callback specified to leave the config checker. Make sure registerLeaveConfigChecker gets called before trying to leave.");
  }

  leaveConfigCheckerCB();
}

export function registerLeaveConfigChecker(leaveConfigChecker) {
  leaveConfigCheckerCB = leaveConfigChecker;
}

export function setHasConnection(newValue){
  hasConnection = newValue;
}
